/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Automation/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import BackAction from './BackAction/index'
import EditAutomation from 'DesignSystem/EditAutomation/index'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Automation({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentAutomations/Automation",
  onChange
  
}) {
let tabSelectedEventIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.event_id',
})
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let tabSelectedValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected',
})
let tabSelectedChangeData = fromData.useDataChange({ viewPath,
context: 'tab',
path: 'selected',
})
let onCreate = fromHelpers.useOnCreate({
  children,
  viewPath,
  onChange
  
})
let onUpdate = fromHelpers.useOnUpdate({
  children,
  viewPath,
  onChange
  
})
let onCancel = fromHelpers.useOnCancel({
  children,
  viewPath,
  onChange
  
})
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
 data="tab.selected.event_id"
 eventId={tabSelectedEventIdValueData}
/>
<div
  data-testid="Automation.Vertical"
  data-view-path={viewPath}
 style={{'--pl-1-Z2jmc2o': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-2-Z2jmc2o': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pt-3-Z2jmc2o': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pb-4-Z2jmc2o': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical}`}
>
<BackAction
  viewPath={`${viewPath}/BackAction`}
/>
<div
  data-testid="Automation.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<EditAutomation
  viewPath={`${viewPath}/EditAutomation`}
 data="tab.selected"
 automation={tabSelectedValueData}
 onChange={tabSelectedChangeData}
 onCreate={onCreate}
 onUpdate={onUpdate}
 onCancel={onCancel}
/>
</div>
</div>
{children}
</React.Fragment>)
}